import { ITEM_STATUSES } from '../../../../constants/items';
// still needed for font awesome woff
import '@updater-components/icon';
import template from './step-status.html';
import './step-status.global.css';

const STATUS_ICONS = {
  [ITEM_STATUSES.ALREADY_DONE]: 'check-circle',
  [ITEM_STATUSES.CANCELLED]: 'times-circle',
  [ITEM_STATUSES.COMPLETED]: 'check-circle',
  [ITEM_STATUSES.CONFIRMED]: 'check-circle',
  [ITEM_STATUSES.NOT_NEEDED]: 'times-circle',
  [ITEM_STATUSES.PENDING]: 'clock-o',
  [ITEM_STATUSES.RESERVED]: 'check-circle',
  [ITEM_STATUSES.UNVERIFIED]: 'warning',
  [ITEM_STATUSES.VALIDATING]: 'clock-o',
  [ITEM_STATUSES.CALLED]: 'phone',
};

const CIRCLED_ICONS = [ITEM_STATUSES.CALLED];

const showCompletedDescription = status =>
  [ITEM_STATUSES.COMPLETED, ITEM_STATUSES.ALREADY_DONE].indexOf(status) !== -1;

class TimelineStepStatusController {
  get date() {
    // Only show date for completed steps or if the step has no status
    // (handles special case "Move Date" step that has no status).
    return this.status === ITEM_STATUSES.COMPLETED || !this.status
      ? this.step.statusUpdatedAt
      : undefined;
  }

  get status() {
    return this.step.status;
  }

  get statusText() {
    return this.stepCode === 'tv_internet' &&
      this.status === ITEM_STATUSES.CALLED
      ? 'call required'
      : this.stepCode === 'tv_internet' &&
        this.status === ITEM_STATUSES.RESERVED
      ? 'action required'
      : this.status;
  }

  get statusIcon() {
    return this.stepCode === 'tv_internet' &&
      this.status === ITEM_STATUSES.RESERVED
      ? 'exclamation-circle'
      : STATUS_ICONS[this.status];
  }

  get stepIcon() {
    return this.step.icon;
  }

  get isCircledIcon() {
    return CIRCLED_ICONS.includes(this.status);
  }

  get title() {
    return showCompletedDescription(this.status)
      ? this.step.completedDescription
      : this.step.shortDescription;
  }

  get stepCode() {
    return this.step.code;
  }
}

export const TimelineStepStatusComponent = {
  controller: TimelineStepStatusController,
  bindings: {
    step: '<',
  },
  template,
};
